import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler
} from "react-native";
import HMActionBar from "../../../../customviews/HMActionBar";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
import {moderateScale} from "../../../../tools/Scaling";
import Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
//import MapboxGL from "@mapbox/react-native-mapbox-gl";
import HMListItem2 from "../../../../customviews/HMListItem2";
import i18n from '../../../../I18n/i18n.js';
import {Tools} from "../../../../tools/Tools";
import PathFile from "../../../../assets/PathFile";
import {typeExport} from "../../../../redux/store/type";
import HMDetailsMap from "../../../../customviews/HMDetailsMap";

import HMVideo from "../../../../customviews/video/HMVideo";
import HMIcon from "../../../../customviews/HMIcon";
import HMMap from "../../../../customviews/map/HMMap";

import HMSwiper from "../../../../customviews/swiper/HMSwiper";
import HMModal from "../../../../customviews/modal/HMModal";
import HMImageView from "../../../../customviews/HMImageView";
import axios from "axios";
import Toast from "../../../../customviews/toast";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMBottomBarItem137 from "../../../../customviews/bottombarItem/HMBottomBarItem137";
import * as NavigationService from "../../../../redux/NavigationService";
// import {VideoPlayer} from "react-native-video-processing";
// import Video from "react-native-af-video-player";
//import Orientation from "react-native-orientation";
//import Sound from "react-native-sound";
var sound = null
//Sound.setCategory('Playback');
let container = null;
let container2 = null;

const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;


const theme = {
    title: '#FFF',
    more: '#446984',
    center: '#7B8F99',
    fullscreen: '#446984',
    volume: '#A5957B',
    scrubberThumb: '#234458',
    scrubberBar: '#DBD5C7',
    seconds: '#DBD5C7',
    duration: '#DBD5C7',
    progress: '#446984',
    loading: '#DBD5C7'
}
let backClickCount_value = 0;


export default class DetailsRequestScreen extends Component {
    static navigationOptions = ({navigation}) => {
        const {state} = navigation
        // Setup the header and tabBarVisible status
        const header = state.params && (state.params.fullscreen ? undefined : null)
        const tabBarVisible = state.params ? state.params.fullscreen : true
        return {
            // For stack navigators, you can hide the header bar like so
            header,
            // For the tab navigators, you can hide the tab bar like so
            tabBarVisible,
        }
    }

    constructor(props) {
        super(props);
        let _params = props.route.params;
        //let _item = JSON.parse(_params.item);
        let _item = _params.item;
        container = this;
        let {files} = props.route.params.item;

        let sliderWidth = 1;
        let itemWidth = 1;
        let slideHeight = 1;
        let widthOriginal = Platform.OS === "web" ? 1 : typeExport._WIDTH;
        let viewportWidth = Platform.OS === "web" ? 1 : typeExport._WIDTH;
        let viewportHeight = 1;
        let columnCount = 1;

        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;

            slideHeight = viewportHeight * 0.35;


            sliderWidth = viewportWidth;

            columnCount = viewportWidth > 1000 ? 2 : 1;
        }

        this.state = {
            alaki: false,
            largeMap: false,
            stateItemExtra: props.route.params.item,
            widthOriginal: widthOriginal,
            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            sliderWidth: sliderWidth,
            slideHeight: slideHeight,

            modalHeight: 0,
            isFull: false,


            listVideo: [],
            listImage: _item.arrImage && _item.arrImage.length > 0 ? _item.arrImage : [],
            listVoice: [],
            listOthers: [],
            slider1ActiveSlide: 0,


            ShowImage: false,
            ShowVideo: false,
            visibleModal: '',
            playSeconds: 0.0,
            playState: 'playing'

        };

        if (files)
            for (let i = 0; i < files.length; i++) {
                let f = String(files[i].type);

                if (f.search('audio/') >= 0)
                    this.state.listVoice.push(files[i])

                else if (f.search('image/') >= 0)
                    this.state.listImage.push(files[i])

                else if (f.search('video/') >= 0)
                    this.state.listVideo.push(files[i])
                else {

                    this.state.listOthers.push(files[i])

                }

            }


        this.onFullScreen = this.onFullScreen.bind(this);// you should bind this to the method that call the props

    }

////////////////audio///////////////

    async _pause() {
        sound.pause();

    }

    async _play(audioPath) {


        sound = await
            new Sound(audioPath, '', (error) => {
                if (error) {
                    console.log('failed to load the sound', error);
                    return;
                }
                sound.play((success) => {
                    if (success) {
                        this.setState(
                            {
                                playState: 'playing'
                            },
                            () => {
                                // this._pause()

                            }
                        )
                    } else {
                        console.log('playback failed due to audio decoding errors');
                    }
                });
                if (this.timeout) {
                    clearInterval(this.timeout);
                }
                this.timeout = setInterval(() => {
                    if (sound && sound.isLoaded() && (this.state.playState == 'playing' || this.state.playState == 'paused')) {
                        sound.getCurrentTime((seconds, isPlaying) => {
                            this.setState({playSeconds: seconds});
                        })
                    }
                }, 100);
            });


    }

    switchIcon() {
//playing, paused ,record , stop
        switch (this.state.playState) {
            case 'playing':


                return PathFile.image.img_play

            case 'paused':

                return PathFile.image.img_pause

            default :

        }
    }

    switchOnPress(audioPath) {
        switch (this.state.playState) {


            case 'playing':

                this.setState(
                    {
                        playState: 'paused'
                    },
                    () => {
                        this._play(audioPath)
                    }
                )
                break;

            case 'paused':
                this.setState(
                    {
                        playState: 'playing'
                    },
                    () => {
                        this._pause()

                    }
                )
                break;


            default :

        }


    }

    /////////////////////////
    hiddenModal() {
        if (sound) {
            this.setState({
                    playState: 'playing'
                },
                () => {

                })

            this._pause()

        }
        this.setState({
                visibleModal: ''
            },
            () => {
                // Orientation.unlockAllOrientations();
                // Orientation.lockToPortrait();
            })
    }

    onShow(data) {
        this.setState({
            visibleModal: data,
            Modalcategory: true

        });
    }

    onFullScreen = (value) => {
        // Set the params to pass in fullscreen status to navigationOptions
        this.props.navigation.setParams({
            fullscreen: !value
        })
        if (value) {
            //Orientation.lockToLandscape();
        } else {
            //Orientation.unlockAllOrientations();
            //Orientation.lockToPortrait();
        }
        this.setState({
            isFull: value
        })
    }

    getZoomPanOptions() {
        const animate = true
        const noMoveStart = true
        const easeLinearity = true
        const duration = 100
        return {
            animate,
            duration,
            easeLinearity,
            noMoveStart,
        }
    }

    async onFlyToPress(long, lat) {

        //await this.map.moveTo([ 49.66736778005486,34.08777640387088], 1000);
        /*      this.map.setCamera({
                  //  centerCoordinate: [49.66736778005486, 34.08777640387088],
                  centerCoordinate: [long, lat],
                  zoom: 16,
                  duration: 2000,
              })*/
        if (Platform.OS === "web") {
            //this.map.leafletElement.flyTo(c, 20, this.getZoomPanOptions())
            this.map.mapRef.current.flyTo([lat, long], 18)

        }
        else {
            const camera = await this.map.mapRef.current.getCamera();

            camera.zoom = 17;
            camera.center.latitude = lat;
            camera.center.longitude = long;
            this.map.mapRef.current.animateCamera(camera, {duration: 2000});
            // this.onFlyToComplete();
        }

    }

    centerMap(long, lat) {

        this.map.setCamera({
            //centerCoordinate: [Constants.Longitude, Constants.Latitude],
            centerCoordinate: [long, lat],
            zoom: 16,
            // duration: 2000,
            // mode: MapboxGL.CameraModes.Flight,
        });

    }

    componentWillReceiveProps(propss) {


    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    async componentDidMount() {

        this.getDataDetails();

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                const slideHeight = viewportHeight * 0.35;


                const sliderWidth = viewportWidth;

                container.setState({
                        widthOriginal: document.body.clientWidth,
                        viewportWidth: document.body.clientWidth,
                        widthV: document.body.clientWidth > 600 ? document.body.clientWidth / 2.05 : document.body.clientWidth,

                        //    widthV: document.body.clientWidth,
                        heightV: document.body.clientHeight,
                        // itemWidth: itemWidth,
                        sliderWidth: sliderWidth,
                        slideHeight: slideHeight,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 1000 ? 2 : 1,
                    },
                )


            })
        this.setState({
            // dataSourcearraycategory: this.state.arraycategory,
            // dataSourcearrayBedrooms: this.state.arrayBedrooms
        })


    }

    componentWillMount() {
        let _item = this.state.stateItemExtra;

        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = _item;
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);

        if (sound) {
            sound.release();
            sound = null;
        }
        if (this.timeout) {
            clearInterval(this.timeout);
        }

    }

    handleBackButton = () => {

        if (this.state.visibleModal === 'selectVideo') {
            this.setState({
                visibleModal: ''
            })
        } else {
            this.props.navigation.pop()
        }

        return true;
    };

    render() {
        let {slider1ActiveSlide} = this.state

        const placeholder = 'https://your-url.com/placeholder.png'
        let {type, indexExtra, pageDetails, item_parent} = this.props.route.params;

        let _params = this.props.route.params;
        let _item = this.state.stateItemExtra;
        // let _item = JSON.parse(_params.item);
        let {slider, title, description, latitude, longitude, address, code, status, files, createdtime, comment, video, audio, image, subject, date, category, color, lastWork} = _item;
        //  pageDetails = (item_parent?.type == 7 || type == "requestMahalehMa") ? true : (pageDetails ? pageDetails : !(lastWork && lastWork.length > 0));

        //let {title, description, latitude, longitude, address, code, status, files, createdtime, comment, video, audio, image, subject, date, category, color} = this.props.route.params.item;
        // slider = [
        //     {
        //         "id": 1,
        //         "type": "image/jpeg",
        //         "file": "https://tcloud.shahrban.org//uploads/watermarked_2.jpg109.jpg",
        //         "display": true,
        //         "source": null,
        //         "label": null,
        //         "duration": null
        //     },
        //     {
        //         "id": 2,
        //         "type": "image/jpeg",
        //         "file": "https://tcloud.shahrban.org//uploads/watermarked_5-11122022121359959.jpg",
        //         "display": true,
        //         "source": null,
        //         "label": null,
        //         "duration": ""
        //     },
        //     {
        //         "id": 3,
        //         "type": "image/jpeg",
        //         "file": "https://tcloud.shahrban.org//uploads/watermarked_IMG_8240-1024x683.jpg747.jpg",
        //         "display": true,
        //         "source": null,
        //         "label": null,
        //         "duration": null
        //     }
        // ];
        let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type.search('audio/') >= 0)?.file));
        let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type.search('video/') >= 0)?.file));
        //let checkImage = image || video === null ? video : (files && files.length > 0 && (files.find(k => k.type.search('image/') >= 0)?.file));
        //
        // checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type.search('audio/') >= 0)) && (files.find(k => k.type.search('audio/') >= 0)).file);
        // checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type.search('video/') >= 0)) && (files.find(k => k.type.search('video/') >= 0)).file);

        let heightSlider = (this.state.viewportWidth > 600) ? 500 : (Platform.OS === "web" ? this.state.viewportWidth : typeExport.WIDTH) / 1.6;
        return (
            <View style={{flex: 1,}}>
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar menu={_params.type !== typeExport._Shahrdar}
                                     props={this.props}
                                     statusBarTransparent
                            //   text={i18n.t('Privatizations.title')}
                                     text={i18n.t('constant.Details')}
                                     headerVisibility
                                     more_menu
                                     back
                                     onBackPress={() => this.props.navigation.pop()}

                        />

                        <ScrollView
                            // ref={scroll => this._onRef('_scroll', scroll)}
                            style={{
                                //  backgroundColor: "white"
                            }}>

                            <View style={{flex: 1,}}>
                                {
                                    this.state.stateItemExtra?.slider?.length > 0 ?
                                        <View
                                            style={{
                                                width: "100%",
                                                // height: this.state.viewportWidth / 1.6,
                                                height: heightSlider,
                                                //marginTop:moderateScale(6),
                                                // backgroundColor:"#2bee8f"
                                            }}
                                        >
                                            <HMSwiper
                                                list={slider}
                                                notLoop
                                                notClick
                                                notAutoPlay
                                                // item={item}
                                                renderItem={() => {
                                                    return slider.map((itemSwiper, indexSwiper) => {
                                                        // let tttt = this.state["isLoading" + index + "SetDisplayImage" + indexSwiper];

                                                        return <DynamicContentSlide
                                                            itemSwiper={itemSwiper}
                                                            indexSwiper={indexSwiper}
                                                            itemParent={_item}


                                                        />

                                                    })
                                                }}

                                            />
                                        </View>
                                        :
                                        null
                                }


                                <HMListItem2
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(8)}}
                                    title={title ? title : subject}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                    text={"عنوان"}
                                />
                                <HMListItem2
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(0)}}
                                    styleTitle={color ? {color: color} : {}}
                                    title={status}
                                    typeIcon={"AntDesign"}
                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"carryout"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                    text={"وضعیت"}

                                />

                                {/*  <HMListItem2
                                    // title={"معرفی دوستان"}

                                    title={"درخواست جمع آوری متکدیان اجتماعی"}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-paper"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                />*/}
                                <HMListItem2
                                    // title={"معرفی دوستان"}
                                    title={createdtime ? createdtime : date}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-calendar"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                    text={"تاریخ"}

                                />
                                <HMListItem2
                                    title={description}
                                    // title={"به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده استفاده می نماید، تا از نظر گرافیکی نشانگر چگونگی نوع و اندازه فونت و ظاهر متن باشد. معمولا طراحان گرافیک برای صفحه‌آرایی، نخست از متن‌های آزمایشی و بی‌معنی استفاده می‌کنند تا صرفا به مشتری یا صاحب کار خود نشان دهند که صفحه طراحی یا صفحه بندی شده بعد از اینکه متن در آن قرار گیرد چگونه به نظر می‌رسد و قلم‌ها و اندازه‌بندی‌ها چگونه در نظر گرفته شده‌است. از آنجایی که طراحان عموما نویسنده متن نیستند و وظیفه رعایت حق تکثیر متون را ندارند و در همان حال کار آنها به نوعی وابسته به متن می‌باشد آنها با استفاده از محتویات ساختگی، صفحه گرافیکی خود را صفحه‌آرایی می‌کنند تا مرحله طراحی و صفحه‌بندی را به پایان برند."}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-list"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        this.onShare()
                                    }}
                                    text={"توضیحات"}

                                />

                                <HMListItem2
                                    title={checkVideo ? i18n.t('constant.View') : null}
                                    file={"video"}
                                    props={this.props}
                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-videocam"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        //this.onShare()
                                    }}
                                    onPressChild={
                                        () => this.setState({
                                            visibleModal: "selectVideo",
                                            pathVideo: checkVideo,
                                            sliderList: [checkVideo],
                                        })
                                    }
                                    text={"ویدیو"}

                                />

                                <HMListItem2
                                    title={checkAudio ? i18n.t('constant.View') : null}
                                    file={"video"}
                                    props={this.props}
                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-mic"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        //this.onShare()
                                    }}
                                    onPressChild={
                                        () => this.setState({
                                            //  visibleModal: "selectaudio",
                                            visibleModal: "selectVideo",
                                            pathVideo: checkAudio,
                                            sliderList: [checkAudio],
                                        })
                                    }
                                    text={"صدا"}

                                />
                                <HMListItem2

                                    title={this.state.listImage.length > 0 ? i18n.t('constant.View') : null}
                                    // title={this.state.listImage.length > 0 ? i18n.t('constant.View') : null}
                                    file={"aaaa"}
                                    path={this.state.listImage.length > 0 ? this.state.listImage : null}
                                    props={this.props}

                                    // title={checkImage ? i18n.t('constant.View') : null}
                                    // file={"image"}
                                    // path={checkImage ? checkImage : null}
                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-image"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        //   this.onShare()
                                    }}
                                    text={"عکس"}
                                    onPressChild={
                                        () => this.setState({
                                            visibleModal: "selectSlider",
                                            // pathVideo: checkVideo
                                            sliderList: this.state.listImage
                                        })
                                    }
                                />

                                <View
                                    style={{
                                        flex: 1,
                                    }}>
                                    <View style={{

                                        flexDirection: 'row',
                                        ///  backgroundColor:'#a8ee7c',
                                        marginHorizontal: moderateScale(5),
                                        marginTop: moderateScale(8),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        alignSelf: 'center',
                                    }}>
                                        <HMTextView


                                            type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(14),
                                                color: Colors.blackLight,
                                                textAlign: 'center',
                                                // marginTop: moderateScale(10)
                                            }}
                                            text={'پاسخ مرکز ارتباطات مردمی'}
                                            //   text={"98/03/21"}
                                        />


                                    </View>
                                    <FlatList
                                        // ItemSeparatorComponent={
                                        //     <View style={{
                                        //         width: '100%',
                                        //         height: moderateScale(1),
                                        //         backgroundColor: '#4f4f4f'
                                        //     }}/>
                                        // }
                                        data={comment === null || !comment ? [] : comment}
                                        renderItem={({item: itemLastWork, index}) => {
                                            let {files} = itemLastWork;
                                            return <View
                                                style={{
                                                    // width: "100%",
                                                    flex: 1,
                                                    marginHorizontal: moderateScale(10),
                                                    //  marginVertical: moderateScale(2),
                                                    // padding: moderateScale(6)
                                                }}>
                                                {/*     <Card>
                                                    <CardItem cardBody style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                    }}>*/}
                                                <View
                                                    style={{
                                                        //paddingVertical: moderateScale(10),
                                                        width: '100%',
                                                        borderRadius: moderateScale(5),
                                                        backgroundColor: Colors.backgroundColor,
                                                        marginVertical: moderateScale(4),
                                                        padding: moderateScale(6)
                                                    }}
                                                >


                                                    <View style={{
                                                        width: "100%",
                                                        flexDirection: 'row',
                                                        justifyContent: "space-between",
                                                        paddingHorizontal: moderateScale(8),
                                                        paddingVertical: moderateScale(2),
                                                    }}>
                                                        <HMTextView

                                                            type={"bold"}
                                                            noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(12),
                                                                color: Colors.colorDarkText,

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            text={itemLastWork.user}
                                                            // text={moment(item.datetime).locale('fa').format('YYYY/M/D HH:mm:ss')}
                                                            /*           text={moment('2013-8-25 16:40:00', 'YYYY-M-D HH:mm:ss')
                                                                           .locale('fa')
                                                                           .format('YYYY/M/D HH:mm:ss')}  */

                                                            //  text={moment(item.datetime, 'YYYY-M-D HH:mm:ss').locale('fa').format('jYYYY/jM/jD HH:mm:ss')}
                                                            /*      text={moment('2013-8-25 16:40:00', 'YYYY-M-D HH:mm:ss')
                                                                      .locale('fa')
                                                                      .format('YYYY/M/D HH:mm:ss')}*/
                                                            // text={moment('2013-8-25 16:00:00', 'YYYY-M-D HH:mm:ss').local('fa').format('jYYYY/jM/jD HH:mm:ss')}
                                                            //
                                                            //
                                                            // text={new Date('2013-8-25 16:40:00').toLocaleTimeString('fa-Ir')}
                                                        />
                                                        <HMTextView

                                                            type={"bold"}
                                                            noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(12),
                                                                color: Colors.colorDarkText,

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            text={itemLastWork.date ? itemLastWork.date : itemLastWork.datetime}
                                                            // text={moment(item.datetime).locale('fa').format('YYYY/M/D HH:mm:ss')}
                                                            /*           text={moment('2013-8-25 16:40:00', 'YYYY-M-D HH:mm:ss')
                                                                           .locale('fa')
                                                                           .format('YYYY/M/D HH:mm:ss')}  */

                                                            //  text={moment(item.datetime, 'YYYY-M-D HH:mm:ss').locale('fa').format('jYYYY/jM/jD HH:mm:ss')}
                                                            /*      text={moment('2013-8-25 16:40:00', 'YYYY-M-D HH:mm:ss')
                                                                      .locale('fa')
                                                                      .format('YYYY/M/D HH:mm:ss')}*/
                                                            // text={moment('2013-8-25 16:00:00', 'YYYY-M-D HH:mm:ss').local('fa').format('jYYYY/jM/jD HH:mm:ss')}
                                                            //
                                                            //
                                                            // text={new Date('2013-8-25 16:40:00').toLocaleTimeString('fa-Ir')}
                                                        />
                                                    </View>
                                                    <View style={{
                                                        width: '100%',
                                                        height: moderateScale(1),
                                                        backgroundColor: '#eee',
                                                        alignSelf: 'center',

                                                    }}/>
                                                    {/*        <View
                                                        style={{
                                                        flexDirection: 'row',
                                                        flex: 1,
                                                        marginVertical: moderateScale(6),
                                                        marginHorizontal: moderateScale(3)
                                                    }}>
                                                        <HMTextView

                                                            type={"bold"}
                                                            noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(12),
                                                                color: Colors.colorDark,

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            text={item.comment}
                                                            //   text={"98/03/21"}
                                                            styleRoot={{
                                                                //  flexDirection: "row",
                                                                flex: 1,
                                                                //  width:'100%',
                                                                //   justifyContent: "flex-end",
                                                                flexWrap: 'wrap',

                                                            }}
                                                        />
                                                    </View>*/}


                                                    <HMTextView

                                                        type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(14),
                                                            color: Colors.colorDarkText,
                                                            margin: moderateScale(6),

                                                            // marginTop: moderateScale(10)
                                                        }}
                                                        text={itemLastWork.comment ? itemLastWork.comment : ""}
                                                    />


                                                    {this.renderFiles(itemLastWork)}

                                                    {/*
                                                    <HMTextView

                                                        // type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(12),
                                                            color: Colors.colorDarkText,
                                                            margin: moderateScale(6)

                                                            // marginTop: moderateScale(10)
                                                        }}
                                                        text={itemLastWork.time ? itemLastWork.time : ""}
                                                        styleRoot={{
                                                            width: "100%",
                                                            flexDirection: "row",

                                                        }}
                                                    />*/}
                                                    {/*   <View style={{
                                                            width: '100%',
                                                            height: moderateScale(1),
                                                            backgroundColor: '#4f4f4f'
                                                        }}/>*/}


                                                </View>
                                                {/*       </CardItem>
                                                </Card>*/}
                                            </View>
                                        }

                                        }
                                    />


                                </View>

                                {
                                    latitude && latitude != null && latitude != '' && latitude != 'null' ?
                                        <View>
                                            <View
                                                onPress={() => {
                                                }
                                                    /*  NavigationService.navigateParams("MapShowScreen", {
                                                       //   latitude: data.latitude, longitude: data.longitude
                                                      })*/
                                                } style={{
                                                width: "100%",
                                                //height: moderateScale(200)
                                                height: (this.state.widthOriginal > 600) ? 500 : (Platform.OS === "web" ? this.state.widthOriginal : typeExport.WIDTH) / 1.8

                                            }}>
                                                <HMMap
                                                    ref={ref => (this.map = ref)}
                                                    //   provider={PROVIDER_GOOGLE} // remove if not using Google Maps
                                                    showPlace
                                                    provider="google"


                                                    style={{
                                                        width: "100%",
                                                        //height:height-moderateScale(200),
                                                        height: "100%", marginBottom: this.state.marginBottom
                                                    }}
                                                    initialRegion={{
                                                        latitude: parseFloat(latitude),
                                                        longitude: parseFloat(longitude),
                                                        latitudeDelta: 0.015,
                                                        longitudeDelta: 0.0121,
                                                    }}


                                                    coordinate={{
                                                        latitude: parseFloat(latitude),
                                                        longitude: parseFloat(longitude),
                                                        latitudeDelta: 0.015,
                                                        longitudeDelta: 0.0121,
                                                    }}
                                                    // doubleClickZoom={false}
                                                    //closePopupOnClick={false}
                                                    //  dragging={false}
                                                    //  zoomSnap={false}
                                                    // zoomDelta={false}
                                                    //zoomControl={false}
                                                    scrollWheelZoom={false}
                                                    // touchZoom={false}
                                                    //trackResize={false}
                                                    //tap={false}

                                                >
                                                    {/*  <MapView.Marker coordinate={{
                                                    latitude: parseFloat(latitude),
                                                    longitude: parseFloat(longitude),
                                                    latitudeDelta: 0.015,
                                                    longitudeDelta: 0.0121,
                                                }}/>*/}

                                                </HMMap>

                                                {/*<MapboxGL.MapView*/}
                                                {/*//showUserLocation={true}*/}
                                                {/*ref={ref => (this.map = ref)}*/}

                                                {/*zoomLevel={15}*/}
                                                {/*//  userTrackingMode={MapboxGL.UserTrackingModes.Follow}*/}
                                                {/*//  styleURL={this.state.styleURL}*/}
                                                {/*style={{*/}
                                                {/*width: "100%",*/}
                                                {/*height: "100%",*/}
                                                {/*}}*/}
                                                {/*centerCoordinate={[parseFloat(longitude), parseFloat(latitude)]}*/}

                                                {/**/}
                                                {/*>*/}
                                                {/*<MapboxGL.PointAnnotation*/}
                                                {/*key="key1"*/}
                                                {/*id="id1"*/}
                                                {/*title="Test"*/}
                                                {/*zoomLevel={16}*/}
                                                {/*// coordinate={[Constants.Longitude, Constants.Latitude]}*/}
                                                {/*coordinate={[parseFloat(longitude), parseFloat(latitude)]}*/}
                                                {/*>*/}

                                                {/*<HMIcon*/}
                                                {/*raised*/}
                                                {/*name='md-pin'*/}
                                                {/*color={Colors.gray}*/}
                                                {/*style={{*/}
                                                {/*fontSize: moderateScale(22),*/}
                                                {/*color: Colors.colorSecondPrimary,*/}
                                                {/*textAlign: "center",*/}

                                                {/*// padding: moderateScale(4),*/}

                                                {/*}}*/}
                                                {/*/>*/}
                                                {/*<MapboxGL.Callout title={title}/>*/}
                                                {/*</MapboxGL.PointAnnotation>*/}
                                                {/*</MapboxGL.MapView>*/}


                                                {
                                                    // address ?
                                                    1 === 1 ?
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                this.onFlyToPress(parseFloat(longitude), parseFloat(latitude))
                                                            }}

                                                            style={{
                                                                flexDirection: "row",
                                                                padding: moderateScale(5),
                                                                //     justifyContent: "flex-end",
                                                                alignItems: "center",
                                                                width: "100%",
                                                                backgroundColor: "rgba(0, 0, 0, 0.6)",
                                                                position: "absolute",
                                                                bottom: 0,
                                                                left: 0
                                                            }}>
                                                            {/*      <TextView textt={data.address} selfStyle={{
                                            marginHorizontal: moderateScale(10),
                                            color: "white",
                                            fontSize: moderateScale(14),
                                            textAlign: "right",
                                            flex: 1
                                        }}/>*/}
                                                            <HMIcon type={"Feather"} name={"map-pin"}
                                                                    style={{
                                                                        marginEnd: moderateScale(10),
                                                                        fontSize: moderateScale(24),
                                                                        color: Colors.white
                                                                    }}/>
                                                            <HMTextView

                                                                type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: Colors.white,

                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                //text={'اراک خ هپکو خ امام حسین'}
                                                                text={address}
                                                                //   text={"98/03/21"}
                                                            />

                                                        </TouchableOpacity>
                                                        :
                                                        null
                                                }

                                            </View>
                                            {
                                                Platform.OS !== "web" ?
                                                    <HMDetailsMap
                                                        position={{latitude: latitude, longitude: longitude}}/>
                                                    :
                                                    null
                                            }

                                        </View>
                                        : null
                                }


                            </View>

                        </ScrollView>
                        {
                            !this.props.token || (type === "report") || (item_parent?.type == 7 || type == "requestMahalehMa") || !(typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") ?
                                //  1 == 1 ?

                                null
                                :
                                <HMBottomBarItem137
                                    shahrvandFlag={true}
                                    noCheckSwitch={true}
                                    funcSwitch={() => null
                                        // this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)
                                        // this._toggle(false)
                                        // this.getData()
                                    }
                                    funcSend={() => NavigationService.navigateParams("SubmitSendOperationScreen", {
                                        itemExtra: item,
                                        listExtra: this.props.ListSend,
                                        //  res: data
                                    })
                                        // this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)
                                        // this._toggle(false)
                                        // this.getData()
                                    }
                                    funcChangeState={(name, data) => {
                                        this.setState({[name]: data})
                                    }}
                                    funcAddStateItemExtra={(data) => {

                                        // this.state.stateItemExtra.lastWork.unshift(this.addFlagDate([data])[0])

                                        let obj = this.state.stateItemExtra;
                                        obj["comment"] = this.addFlagDate(data);
                                        this.setState({
                                                stateItemExtra: obj,
                                                alaki: !this.state.alaki
                                            },
                                            () => {
                                                //  this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)

                                            });


                                    }}
                                    // funcAlaki={()=>}
                                    itemExtra={this.state.stateItemExtra}
                                    indexExtra={this.props.route.params.indexExtra}/>
                        }
                        {
                            this.state.visibleModal === 'selectSlider' || this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                <View
                                    style={{
                                        position: 'absolute',
                                        flex: 1,
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginTop: Platform.OS === 'ios' ? moderateScale(15) : 0,
                                        top: 0,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        backgroundColor: 'rgba(0,0,0,0.7)',
                                        zIndex: 9900
                                    }}>
                                    <View
                                        style={{
                                            height: "100%",
                                            width: '100%',
                                            // padding: moderateScale(6),
                                            backgroundColor: Colors.black,
                                            position: 'relative'
                                        }}>
                                        {
                                            <View
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 0,
                                                    left: 0,
                                                    bottom: 0,
                                                }}

                                            >
                                                {/*<FlatList*/}
                                                {/*ref={(ref) => { this.flatListRef = ref }}*/}
                                                {/*data={[1,2,3,4,5]}*/}
                                                {/*extraData={this.state}*/}
                                                {/*//  onScroll={(e) => this.pauseAll(e)}*/}
                                                {/*showsHorizontalScrollIndicator={false}*/}
                                                {/*// scrollEnabled={this.state.isPortrait}*/}
                                                {/*horizontal={true}*/}
                                                {/*renderAheadOffset={0}*/}
                                                {/*initialNumToRender={5}*/}
                                                {/*windowSize={5}*/}
                                                {/*removeClippedSubviews={true}*/}
                                                {/*pagingEnabled={true}*/}
                                                {/*keyExtractor={(item, id) => id.toString()}*/}
                                                {/*renderItem={(item, index) => (this.renderFlatlist(item, index))}*/}
                                                {/*/>*/}
                                                <HMSwiper
                                                    list={this.state.sliderList}
                                                    renderItem={() =>
                                                        this.state.sliderList.map((item, index) => {
                                                            let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = _item;

                                                            return <View
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%'
                                                                }}
                                                            >

                                                                {
                                                                    this.state.visibleModal === 'selectSlider' ?
                                                                        <Image
                                                                            resizeMode={"contain"}
                                                                            style={{
                                                                                flex: 1,
                                                                            }}
                                                                            // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                                                                            source={{uri: item.file ? item.file : item}}
                                                                        />
                                                                        :
                                                                        null
                                                                }
                                                                {/*{*/}
                                                                {/*this.state.visibleModal === 'selectVideo11' ?*/}
                                                                {/*<Video*/}
                                                                {/*style={{*/}
                                                                {/*flex: 1,*/}
                                                                {/*resizeMode: 'contain'*/}
                                                                {/*}}*/}
                                                                {/*autoPlay={false}*/}
                                                                {/*// paused={this.state["paused" + item.index]}*/}
                                                                {/*// ref={(ref) => this.video = {...this.video, [`REF-FLATLIST${index}`]: ref}}*/}
                                                                {/*ref={(ref) => {*/}
                                                                {/*//  ...this.video$, [`REF-FLATLIST${item.key}`]: ref*/}
                                                                {/*// this[`video${index}`]=ref*/}
                                                                {/*this["video" + item.index] = ref*/}
                                                                {/*}}*/}

                                                                {/*// autoPlay*/}
                                                                {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
                                                                {/*//   url={this.state.pathVideo ? this.state.pathVideo : null}*/}
                                                                {/*// url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
                                                                {/*//   url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
                                                                {/*url={item.file}*/}
                                                                {/*title={title}*/}
                                                                {/*// logo={logo}*/}
                                                                {/*//    placeholder={placeholder}*/}
                                                                {/*//  onMorePress={() => this.onMorePress()}*/}
                                                                {/*onFullScreen={status => {*/}
                                                                {/*// this["video" + item.index].pause()*/}
                                                                {/*this.onFullScreen(status)*/}
                                                                {/*}*/}
                                                                {/*}*/}
                                                                {/*//   fullScreenOnly*/}
                                                                {/*theme={theme}*/}
                                                                {/*/>*/}

                                                                {/*:*/}
                                                                {/*null*/}
                                                                {/*}*/}
                                                                {
                                                                    this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                                                        <HMVideo
                                                                            title={title}
                                                                            navigation={this.props.navigation}
                                                                            item={item} index={item.index}
                                                                            indexSelect={this.state.slider1ActiveSlide}
                                                                            //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                                                                        />

                                                                        :
                                                                        null
                                                                }
                                                                {/*{*/}
                                                                {/*this.state.visibleModal === 'selectaudio' ?*/}
                                                                {/*<Video*/}
                                                                {/*style={{flex: 1, resizeMode: 'contain'}}*/}
                                                                {/*autoPlay={false}*/}
                                                                {/*ref={(ref) => {*/}
                                                                {/*this.video = ref*/}
                                                                {/*}}*/}
                                                                {/*// autoPlay*/}
                                                                {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
                                                                {/*url={item.file}*/}
                                                                {/*title={title}*/}
                                                                {/*// logo={logo}*/}
                                                                {/*//  placeholder={placeholder}*/}
                                                                {/*//  onMorePress={() => this.onMorePress()}*/}
                                                                {/*onFullScreen={status => this.onFullScreen(status)}*/}
                                                                {/*//   fullScreenOnly*/}
                                                                {/*theme={theme}*/}
                                                                {/*/>*/}
                                                                {/*:*/}
                                                                {/*null*/}
                                                                {/*}*/}

                                                            </View>

                                                        })
                                                    }
                                                />


                                                {/*     <Carousel page

                                                          ref={c => this._slider1Ref = c}
                                                          data={this.state.sliderList}
                                                    //    data={[1, 2, 3, 4, 5].}
                                                    //    data={this.state.entries}
                                                          renderItem={(item, index) => this.renderCarousel(item, index)


                                                          }
                                                    // inactiveSlideScale={.99}
                                                    // sliderWidth={sliderWidth}
                                                    // itemWidth={itemWidth}

                                                          inactiveSlideScale={1}
                                                    // sliderWidth={sliderWidth}
                                                    // itemWidth={itemWidth}

                                                          sliderWidth={Dimensions.get('window').width}
                                                          itemWidth={Dimensions.get('window').width}
                                                          hasParallaxImages={true}
                                                          firstItem={0}

                                                          inactiveSlideOpacity={0.7}
                                                    // inactiveSlideShift={20}
                                                          containerCustomStyle={styles_Carousel.slider}
                                                          contentContainerCustomStyle={styles_Carousel.sliderContentContainer}
                                                    // loop={true}
                                                    //loopClonesPerSide={1}
                                                    //    autoplay={true}
                                                    //   autoplayDelay={1000}
                                                    //   autoplayInterval={6000}
                                                          onSnapToItem={(index, item) => {


                                                              let p = "paused" + slider1ActiveSlide
                                                              this.setState({
                                                                  [p]: true,
                                                                  slider1ActiveSlide: index
                                                              }, () => {
                                                              })
                                                          }
                                                          }
                                                          removeClippedSubviews={false}
                                                />*/}
                                            </View>
                                        }
                                        {/*     <View
                                            style={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: typeExport._WIDTH,
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Pagination
                                                //  data={[1, 2, 3, 4, 5]}
                                                dotsLength={this.state.sliderList.length}
                                                activeDotIndex={slider1ActiveSlide}
                                                containerStyle={styles.paginationContainer}
                                                //  dotColor={'rgba(255, 255, 255, 0.92)'}
                                                dotColor={Colors.colorSecondPrimary}
                                                dotStyle={styles.paginationDot}
                                                inactiveDotColor={Colors.white}
                                                inactiveDotOpacity={0.4}
                                                inactiveDotScale={0.6}
                                                carouselRef={this._slider1Ref}
                                                tappableDots={!!this._slider1Ref}
                                            />
                                        </View>*/}
                                    </View>
                                    <TouchableOpacity
                                        onPress={() => {
                                            this.hiddenModal()
                                        }}

                                        style={{
                                            width: moderateScale(32),
                                            height: moderateScale(32),
                                            // backgroundColor: '#ee005b',
                                            position: 'absolute',
                                            borderRadius: moderateScale(16),
                                            margin: moderateScale(4),
                                            top: 0,
                                            left: 0,
                                            alignItems: 'center',
                                            justifyContent: 'center',

                                        }}>
                                        <HMIcon name={"ios-close-circle-outline"} style={{
                                            textAlign: 'center',
                                            //alignSelf: 'flex-end',
                                            color: Colors.white,
                                            // width: moderateScale(32),
                                            // height: moderateScale(32),
                                            fontSize: moderateScale(22)
                                        }}/>
                                    </TouchableOpacity>
                                </View>
                                :
                                null
                        }
                        <HMModal
                            isVisible={this.state.visibleModal === 'selectaudio'}
                            backdropColor={Colors.gray}
                            backdropOpacity={0.8}
                            animationIn="zoomInDown"
                            animationOut="zoomOutUp"
                            animationInTiming={600}
                            animationOutTiming={600}
                            backdropTransitionInTiming={600}
                            backdropTransitionOutTiming={600}
                            //style={{height: '60%'}}
                            onBackdropPress={() => this.hiddenModal()}
                            onBackButtonPress={() => this.hiddenModal()}
                        >

                            <View style={{
                                height: "50%",
                                //      padding: moderateScale(6),
                                backgroundColor: Colors.white
                            }}>
                                <View
                                    style={{
                                        flex: 1,
                                        backgroundColor: "#2b608a",
                                    }}>

                                    <View style={{
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flex: 1,
                                    }}>
                                        <View style={{
                                            flex: .4, alignItems: 'center',
                                            justifyContent: 'flex-end',
                                        }}>
                                            {/*<Text*/}
                                            {/*style={styles.progressText}>{Tools.getAudioTimeString(this.state.currentTime)}</Text>*/}
                                        </View>
                                        <View style={{flex: .6, alignItems: 'center'}}>
                                            <TouchableOpacity
                                                style={{
                                                    width: moderateScale(48),
                                                    height: moderateScale(48),
                                                    marginTop: moderateScale(15),
                                                    backgroundColor: Colors.white,
                                                    borderRadius: moderateScale(24),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',

                                                }}
                                                onPress={() => {
                                                    this.switchOnPress(checkAudio)
                                                }}
                                            >
                                                <Image
                                                    source={this.switchIcon(this.state.playState)}
                                                    style={{
                                                        width: moderateScale(24),
                                                        height: moderateScale(24),
                                                        tintColor: Colors.colorDark
                                                    }}/>
                                                {/*<Text style={{position:'absolute', alignSelf:'center', marginTop:1, color:'white', fontSize:12}}>15</Text>*/}
                                            </TouchableOpacity>

                                            <View style={{
                                                width: '100%',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <Text
                                                    style={{
                                                        paddingTop: moderateScale(25),
                                                        fontSize: moderateScale(25),
                                                        color: "#fff"
                                                    }}>{Tools.getAudioTimeString(this.state.playSeconds)}</Text>


                                            </View>


                                        </View>

                                    </View>


                                    <TouchableOpacity
                                        style={{

                                            //    marginHorizontal: moderateScale(10),
                                            width: moderateScale(48),
                                            height: moderateScale(48),

                                            justifyContent: 'center',
                                            alignItems: 'center',

                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            marginTop: Platform.OS === 'ios' ? moderateScale(16) : 0
                                            // bottom:0,
                                        }}

                                        onPress={
                                            () => {
                                                this.setState(
                                                    {
                                                        // ShowAudio:f,
                                                        visibleModal: '',

                                                    }
                                                )
                                            }

                                        }>
                                        <View style={{
                                            //  flexDirection:Rtl ? 'row-reverse': 'row',
                                            flexDirection: 'row',
                                            alignItems: "flex-end",
                                            //marginHorizontal: moderateScale(4)
                                        }}>
                                            <HMIcon name={
                                                //Rtl ? "ios-arrow-back":'ios-arrow-forward'
                                                I18nManager.isRTL ? "ios-arrow-back" : 'ios-arrow-forward'
                                                // 'ios-arrow-back'

                                            }
                                                    style={{fontSize: moderateScale(26), color: Colors.light}}/>
                                            {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                            {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                        </View>
                                    </TouchableOpacity>

                                </View>

                            </View>
                        </HMModal>
                        {
                            // this.state.visibleModal === 'selectVideo' ?
                            //     <View
                            //         style={{
                            //             position: 'absolute',
                            //             flex: 1,
                            //             alignContent: 'center',
                            //             alignItems: 'center',
                            //             justifyContent: 'center',
                            //             marginTop: Platform.OS === 'ios' ? moderateScale(15) : 0,
                            //             top: 0,
                            //             bottom: 0,
                            //             right: 0,
                            //             left: 0,
                            //             backgroundColor: 'rgba(0,0,0,0.7)',
                            //             zIndex: 9900
                            //         }}>
                            //         <View
                            //             style={{
                            //                 height: "100%",
                            //                 width: '100%',
                            //                 // padding: moderateScale(6),
                            //                 backgroundColor: Colors.black
                            //             }}>
                            //             <HMVideo
                            //                 title={title}
                            //                 navigation={this.props.navigation}
                            //                 indexSelect={this.state.slider1ActiveSlide}
                            //                 offline={!files}
                            //                 video={video}
                            //                 path={this.state.pathVideo ? this.state.pathVideo : null}
                            //                 //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                            //             />
                            //             {/* {
                            //                 files ?
                            //                     <Video
                            //                         style={{flex: 1, resizeMode: 'contain'}}
                            //                         autoPlay={false}
                            //                         ref={(ref) => {
                            //                             this.video = ref
                            //                         }}
                            //                         // autoPlay
                            //                         //  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}
                            //                         //     url={checkVideo ? checkVideo : null}
                            //                         url={this.state.pathVideo ? this.state.pathVideo : null}
                            //
                            //                         title={title}
                            //                         // logo={logo}
                            //                         placeholder={placeholder}
                            //                         //  onMorePress={() => this.onMorePress()}
                            //                         onFullScreen={status => this.onFullScreen(status)}
                            //                         //   fullScreenOnly
                            //                         theme={theme}
                            //                     />
                            //                     :
                            //                     <VideoPlayer
                            //                         ref={ref => this.videoPlayerRef = ref}
                            //                         //  startTime={0}  // seconds
                            //                         //  endTime={60}   // seconds
                            //                         //    play={true}     // default false
                            //                         //  replay={true}   // should player play video again if it's ended
                            //                         rotate={true}   // use this prop to rotate video if it captured in landscape mode iOS only
                            //                         source={video}
                            //                         //   playerWidth={300} // iOS only
                            //                         //  playerHeight={500} // iOS only
                            //                         style={{
                            //                             //backgroundColor: 'black',
                            //                             flex: 1,
                            //                         }}
                            //                         resizeMode={VideoPlayer.Constants.resizeMode.CONTAIN}
                            //                         onChange={({nativeEvent}) => {
                            //                         }} // get Current time on every second
                            //                     />
                            //             }*/}
                            //
                            //
                            //         </View>
                            //         <TouchableOpacity
                            //             onPress={() => {
                            //                 this.hiddenModal()
                            //             }}
                            //
                            //             style={{
                            //                 width: moderateScale(32),
                            //                 height: moderateScale(32),
                            //                 // backgroundColor: '#ee005b',
                            //                 position: 'absolute',
                            //                 borderRadius: moderateScale(16),
                            //                 margin: moderateScale(4),
                            //                 top: 0,
                            //                 left: 0,
                            //                 alignItems: 'center',
                            //                 justifyContent: 'center',
                            //
                            //             }}>
                            //             <HMIcon name={"ios-close-circle-outline"} style={{
                            //                 textAlign: 'center',
                            //                 //alignSelf: 'flex-end',
                            //                 color: Colors.white,
                            //                 // width: moderateScale(32),
                            //                 // height: moderateScale(32),
                            //                 fontSize: moderateScale(22)
                            //             }}/>
                            //         </TouchableOpacity>
                            //     </View>
                            //     : null
                        }

                        {
                            this.state.isLoading ?
                                <DialogLoadingCustomize/>
                                : null
                        }


                        {
                            this.state.NoInternetDialog ?
                                <DialogConnectionCustomize onPress={() => this.getDataDetails()}/> : null
                        }
                        {!this.state.largeMap ?
                            null
                            :
                            <View style={[{
                                width: "100%",
                                height: "100%",
                                position: "absolute",
                            }]}>
                                {
                                    this.renderMap(latitude, longitude, true)
                                }
                                <TouchableOpacity
                                    style={{
                                        width: moderateScale(48),
                                        height: moderateScale(48),
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        padding: moderateScale(8),
                                        backgroundColor: Colors.red,
                                        borderRadius: moderateScale(24),
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onPress={() => {
                                        this.setState({largeMap: false})
                                    }}
                                >
                                    <HMIcon name={"ios-close"}
                                            style={{color: Colors.white, fontSize: moderateScale(28)}}/>
                                </TouchableOpacity>
                            </View>
                        }

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    renderCarousel(item, index) {
        let _item = this.state.stateItemExtra;

        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = _item;

        return <View
            style={{
                width: '100%',
                height: '100%'
            }}
        >

            {
                this.state.visibleModal === 'selectSlider' ?
                    <Image
                        resizeMode={"contain"}
                        style={{
                            flex: 1,
                        }}
                        // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                        source={{uri: item.item.file}}
                    />
                    :
                    null
            }
            {/*{*/}
            {/*this.state.visibleModal === 'selectVideo11' ?*/}
            {/*<Video*/}
            {/*style={{*/}
            {/*flex: 1,*/}
            {/*resizeMode: 'contain'*/}
            {/*}}*/}
            {/*autoPlay={false}*/}
            {/*// paused={this.state["paused" + item.index]}*/}
            {/*// ref={(ref) => this.video = {...this.video, [`REF-FLATLIST${index}`]: ref}}*/}
            {/*ref={(ref) => {*/}
            {/*//  ...this.video$, [`REF-FLATLIST${item.key}`]: ref*/}
            {/*// this[`video${index}`]=ref*/}
            {/*this["video" + item.index] = ref*/}
            {/*}}*/}

            {/*// autoPlay*/}
            {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
            {/*//   url={this.state.pathVideo ? this.state.pathVideo : null}*/}
            {/*// url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
            {/*//   url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
            {/*url={item.file}*/}
            {/*title={title}*/}
            {/*// logo={logo}*/}
            {/*//    placeholder={placeholder}*/}
            {/*//  onMorePress={() => this.onMorePress()}*/}
            {/*onFullScreen={status => {*/}
            {/*// this["video" + item.index].pause()*/}
            {/*this.onFullScreen(status)*/}
            {/*}*/}
            {/*}*/}
            {/*//   fullScreenOnly*/}
            {/*theme={theme}*/}
            {/*/>*/}

            {/*:*/}
            {/*null*/}
            {/*}*/}
            {
                this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                    <HMVideo
                        title={title}
                        navigation={this.props.navigation} item={item} index={item.index}
                        indexSelect={this.state.slider1ActiveSlide}
                        //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                    />

                    :
                    null
            }
            {/*{*/}
            {/*this.state.visibleModal === 'selectaudio' ?*/}
            {/*<Video*/}
            {/*style={{flex: 1, resizeMode: 'contain'}}*/}
            {/*autoPlay={false}*/}
            {/*ref={(ref) => {*/}
            {/*this.video = ref*/}
            {/*}}*/}
            {/*// autoPlay*/}
            {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
            {/*url={item.item.file}*/}
            {/*title={title}*/}
            {/*// logo={logo}*/}
            {/*//  placeholder={placeholder}*/}
            {/*//  onMorePress={() => this.onMorePress()}*/}
            {/*onFullScreen={status => this.onFullScreen(status)}*/}
            {/*//   fullScreenOnly*/}
            {/*theme={theme}*/}
            {/*/>*/}
            {/*:*/}
            {/*null*/}
            {/*}*/}

        </View>
    }

    renderFiles(itemLastWork) {
        let files = itemLastWork.files;

        return <View
            style={{
                //position:'absolute',
                flexDirection: "row",
                flexWrap: 'wrap',
                flex: 1,

                flexGrow: 1,
                //  alignItems: 'center', justifyContent: 'center',
                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                //  backgroundColor: "#876a79",
            }}>


            {
                files && files.length > 0 ?
                    (files).map((item, key) => {
                        //let f = String(files[key].type);
                        let f = String(item.type);
                        if (f.search('audio/') >= 0)
                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectVideo",
                                        //   pathVideo: checkAudio,
                                        sliderList: [item],

                                        slider1ActiveSlide: 0,
                                        // visibleModal: "selectaudio",
                                        // pathAudio: checkAudio,
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            type={"MaterialCommunityIcons"}
                                            name={"account-tie-voice"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>

                        else if (f.search('image/') >= 0)
                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectSlider",
                                        sliderList: [item],
                                        slider1ActiveSlide: 0
                                    })
                                }}
                            >
                                <HMImageView
                                    resizeMode={'cover'}
                                    uriComplete={item.file}
                                    _backgroundColorLoading={Colors.black}
                                    styleImage={{
                                        //  resizeMode: 'cover',
                                        width: "100%",
                                        height: "100%",
                                        //   backgroundColor: "#ee7e0c",
                                        //  borderTopRightRadius:moderateScale(8),
                                        //  borderTopEndRadius: moderateScale(12),
                                        //  borderTopStartRadius: moderateScale(8),
                                    }}
                                    //  onLoad={this._onLoad}
                                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                                />
                            </TouchableOpacity>
                        else if (f.search('video/') >= 0)
                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectVideo",
                                        // pathVideo: checkVideo,
                                        sliderList: [item],

                                        slider1ActiveSlide: 0
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            name={"play"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>

                        else {


                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectListOthers",
                                        sliderList: [item],
                                        slider1ActiveSlide: 0,
                                        // visibleModal: "selectaudio",
                                        // pathAudio: checkAudio,
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            name={"attach"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>
                        }


                    })
                    :
                    null
            }
            {
                itemLastWork.R_latitude ?
                    <TouchableOpacity
                        style={
                            {
                                width: moderateScale(80),
                                height: moderateScale(80),

                                borderWidth: moderateScale(1),
                                borderColor: Colors.colorDark,
                                borderRadius: moderateScale(6),
                                overflow: "hidden"
                            }
                        }
                        onPress={() => {
                            this.setState({
                                largeMap: !this.state.largeMap
                            })
                        }}
                    >
                        {

                            this.state.largeMap ?
                                null
                                :
                                this.renderMap(itemLastWork.R_latitude, itemLastWork.R_longitude, false)
                            //   this.renderMap("34.08473870284216", "49.688796072605214", false)

                        }


                    </TouchableOpacity>
                    :
                    null
            }
        </View>
    }

    renderMap(latitude, longitude, type) {
        // return null;
        return <HMMap


            ref={ref => (this.map = ref)}
            styleMap={this.state.largeMap ? {

                width: "100%",
                height: "100%",
            } : {
                width: moderateScale(110),
                height: moderateScale(110),
            }}
            style={[{
                width: "100%",
                //height:height-moderateScale(200),
                height: "100%",
                marginBottom: this.state.marginBottom
            },
                // !type?{bottom: -25}:{}
            ]}
            showPlace
            initialRegion={{
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude),
                latitudeDelta: type ? 0.0015 : 0.0035,
                longitudeDelta: type ? 0.00121 : 0.00321,
            }}
            coordinate={{
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude),
                latitudeDelta: type ? 0.0015 : 0.0035,
                longitudeDelta: type ? 0.00121 : 0.00321,
            }}
            zoom={type ? 20 : 14.7}
            typeMap={!type}
            //application
            pitchEnabled={type}

            rotateEnabled={type}

            scrollEnabled={type}

            zoomEnabled={type}

            //web
            zoomControl={type}
            doubleClickZoom={type}
            closePopupOnClick={type}
            dragging={type}
            zoomSnap={type}
            zoomDelta={type}
            trackResize={type}
            touchZoom={type}
            scrollWheelZoom={type}

            showWrap={true}

            attributionControl={type}
        >

        </HMMap>
    }

    getDataDetails(func) {

        let {item} = this.props.route.params;

        if (!((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest"))) {
            return;
        }

        let formData = new FormData();
        formData.append('_operation', typeExport._Contacts);
        formData.append('mode', "GetRequestDetailUser");
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.DataSplashScreen.token);
        formData.append('tokenLaravel', this.props.DataSplashScreen.tokenLaravel);
        let id = ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) ? item.code : item.id;
        formData.append('record', id);

        Tools.addAllFormData(formData);
        container.requestServer(
            formData, (item) => {

                container.setState({
                    stateItemExtra: item ? item : null,
                    alaki: !container.state.alaki,

                }, () => {
                    if (item.files) {

                        let files = item.files;

                        for (let i = 0; i < files.length; i++) {
                            let f = String(files[i].type);

                            if (f.search('audio/') >= 0)
                                this.state.listVoice.push(files[i])

                            else if (f.search('image/') >= 0)
                                this.state.listImage.push(files[i])

                            else if (f.search('video/') >= 0)
                                this.state.listVideo.push(files[i])
                            else {

                                this.state.listOthers.push(files[i])

                            }

                        }

                    }

                    func ? func() : null
                })
            }, null
        );
    }

    requestServer(formData, func, noLoading) {

        container.setState({
            //ShowImage:true
            isLoading: !noLoading,
            NoInternetDialog: false,
            results: null


        })


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);


        axios({
            method: 'post',
            url: typeExport._baseUrlSainaShahrvand,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;
                // fruits.forEach (function(value, key) {
                //     text += key + ' = ' + value;
                // })
                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    func ? func(data.result) : null
                    // container.getDataServerSplash()
                }
                else {
                    Toast.show({
                        // type: 'success | error | info',
                        type: 'custom_error',
                        //  type: data.status ? 'custom_success' : 'custom_error',
                        //  position: 'top | bottom',
                        position: 'top',
                        text1: i18n.t('constant.message'),
                        text2: data && data.message ? data.message : "مجددا تلاش نمایید",
                        visibilityTime: 5000,
                        autoHide: true,
                        //  topOffset: 30,
                        // bottomOffset: 40,
                        onShow: () => {
                        },
                        onHide: () => {
                        }
                    })
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.success,

                })
            }).catch((e) => {
            console.log('error', e)

            Toast.show({
                // type: 'success | error | info',
                type: 'custom_error',
                //  type: data.status ? 'custom_success' : 'custom_error',
                //  position: 'top | bottom',
                position: 'top',
                text1: i18n.t('constant.message'),
                text2: "مجددا تلاش نمایید",
                visibilityTime: 5000,
                autoHide: true,
                //  topOffset: 30,
                // bottomOffset: 40,
                onShow: () => {
                },
                onHide: () => {
                }
            })
            container.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
        })
    }
    addFlagDate(data) {
        if (data && data.length > 0) {
            let result_lastWork = data;
            let arraySearch = [];
            let start = null;
            let end = null;
            let count = 0;
            for (let i = 0; i < result_lastWork.length; i++) {
                let resultDataSplit = arraySearch.find(obj => {
                    //  return obj.date_split === result_lastWork[i].date_split
                    return obj.date_split === result_lastWork[i].date_split
                });

                //
                if (start && count > 0 && !resultDataSplit) {
                    count = 0;
                    end = true;
                    start = null;
                    result_lastWork[i].flagDate = true;
                }
                if (resultDataSplit) {
                    count = +1;

                }
                else {
                    end = null;
                    arraySearch.push(result_lastWork[i])
                    start = result_lastWork[i].date_split;
                    count = 1;
                }

                if (i === result_lastWork.length - 1 && !end) {
                    result_lastWork[i].flagDate = true;
                }
                //if (key === action.index) {
                // if (!resultDataSplit) {
                //     // let ll = val.lastWork.concat(action.data);
                //     arraySearch.push(result_lastWork[i])
                //     result_lastWork[i].flagDate = true;
                //     //   val.lastWork.push(action.data)
                //
                // }
            }


            return result_lastWork;
        }

        return data;

    }
}

class DynamicContentSlide extends React.Component {
    constructor(props) {
        super(props);
        container2 = this;
    }

    state = {
        isButtonDisplayed: true,
        firstPress: true,
        lastTime: true,
        backClickCount: 0


    };

    render() {
        const {itemSwiper, indexSwiper, index, onPress, onPressLike, loadingDisplayImage, _key, itemParent} = this.props;
        const {isButtonDisplayed, firstPress, lastTime} = this.state;
        let timer = false;
        let ViewCustom = onPress ? TouchableOpacity : View;

        return (
            <TouchableOpacity
                //  key={indexSwiper + "_" + index}
                activeOpacity={1}
                onPress={onPressLike}
                style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",

                    // marginHorizontal: moderateScale(4),
                    //  marginBottom:moderateScale(20),
                    //   backgroundColor:index%2===0?'#29ee0f':'#16d8ee',
                    backgroundColor: '#000',
                    //    borderTopRightRadius:moderateScale(8),
                    // borderTopEndRadius: moderateScale(12),
                    // borderTopStartRadius: moderateScale(8),

                    borderRadius: moderateScale(10),
                    overflow: "hidden"
                }}
            >
                <HMImageView
                    resizeMode={'contain'}
                    uriComplete={itemSwiper.file}

                    // uriComplete={"https://137yar.ahvaz.ir/uploads/watermarked_00022045-05102021175016749.jpg"}
                    //    uriComplete={"https://137yar.ahvaz.ir/img/complaint.png"}

                    _backgroundColorLoading={Colors.black}
                    styleImage={{
                        //  resizeMode: 'cover',
                        width: "100%",
                        height: "100%",
                        //  backgroundColor: "#ee7e0c",
                        //  borderTopRightRadius:moderateScale(8),
                        // borderTopEndRadius: moderateScale(12),
                        // borderTopStartRadius: moderateScale(8),
                        borderRadius: moderateScale(10),

                    }}
                    //  onLoad={this._onLoad}
                    //  onError={(e)=>{console.log(e)}} // prevent infinite-loop bug
                />


                <View
                    style={{
                        position: 'absolute',
                        top: moderateScale(10),
                        right: moderateScale(10),
                        width: moderateScale(34),
                        height: moderateScale(34),
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: moderateScale(17),
                        backgroundColor: Colors.blackLight,
                        borderWidth: moderateScale(1),
                        borderColor: Colors.white,
                        //    padding:moderateScale(14)


                    }}

                >

                    <HMIcon
                        type={itemSwiper.source === "ios" || itemSwiper.source === null || itemSwiper.source === "" ? "MaterialCommunityIcons" : null}
                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                        name={itemSwiper.source && itemSwiper.source !== "" ? (itemSwiper.source === "android" ? "ios-logo-android" : (itemSwiper.source === "ios" ? "apple" : "ios-logo-pwa")) : "web"}
                        //resizeMode="stretch"
                        style={[{fontSize: moderateScale(22)},
                            {
                                color: Colors.white
                            }
                        ]}/>

                </View>
                {
                    itemSwiper.title ?

                        <View
                            style={[
                                {
                                    position: 'absolute',
                                    bottom: 0,
                                    height: moderateScale(50),
                                    // height: typeExport._WIDTH / ((results.slider_height ? results.slider_height : 1.6) * 4),
                                    width: '100%',
                                    color: Colors.white,
                                    padding: moderateScale(3),
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }]}
                        >
                            <HMTextView
                                type={"bold"}

                                style={[
                                    {
                                        // position: 'absolute',
                                        //  bottom: 0,
                                        // height: moderateScale(44),
                                        // width: '100%',
                                        textAlign: "center",
                                        color: Colors.white,
                                        fontSize: moderateScale(13),
                                        //  padding: moderateScale(1),

                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                    }]}
                                numberOfLines={2}
                                text={itemSwiper.title}
                            />
                        </View>
                        : null
                }
            </TouchableOpacity>
        );
    }


}

const styles = StyleSheet.create({

    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});

